/**
 * Une carte posée sur du papier de brouillon (petits carreaux + marge rouge)
 * et une note écrite à la main, comme corrigée par le prof. Sert aux cartes
 * « exercice terminé » du Feed.
 */

'use client';

import './paper.css';
import type { ReactNode } from 'react';
import { cn } from '../../lib/utils';
import { teacherInk } from './teacher-note-text';

export function PaperSheetCard({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('pp-root pp-sheet-card', className)} data-testid="paper-sheet-card">
      {children}
    </div>
  );
}

/** Note manuscrite (« 100 % »), penchée, à l'encre du score (vert / orange / rouge). */
export function HandGrade({ value, className }: { value: number; className?: string }) {
  return (
    <span
      className={cn('pp-hand-grade', className)}
      aria-label={`${value} %`}
      data-testid="hand-grade"
      data-ink={teacherInk(value)}
    >
      {value}
      <span className="pp-hand-grade-pct" aria-hidden>
        %
      </span>
    </span>
  );
}
